










import { Vue, Component } from 'vue-property-decorator';
import ClientesCanal from '@/pantallas/ClientesCanal/ClientesCanal.vue';

@Component({
  components: { ClientesCanal },
})
export default class ClientesCanalPantalla extends Vue {}
